import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-primary via-secondary to-accent">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-white/10 backdrop-blur-sm mb-6 md:mb-8">
            <Icon name="Rocket" size={40} color="#FFFFFF" strokeWidth={2} />
          </div>
          
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6">
            Ready to Transform Your Retail Business?
          </h2>
          
          <p className="font-body text-base md:text-lg text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto">
            Join thousands of Nigerian retailers who trust Cultaz for their inventory management and POS needs. Start your free trial today or explore our desktop solution.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            <a
              href="https://app.cultaz.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              <Button
                variant="default"
                size="lg"
                iconName="ArrowRight"
                iconPosition="right"
                className="bg-white text-primary hover:bg-white/90 w-full sm:w-auto"
              >
                Start Free Trial
              </Button>
            </a>
            
            <Link to="/pricing" className="w-full sm:w-auto">
              <Button
                variant="outline"
                size="lg"
                iconName="DollarSign"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10 w-full sm:w-auto"
              >
                View Pricing
              </Button>
            </Link>
          </div>
          
          <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-6 md:gap-8 text-white/80">
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={18} color="#FFFFFF" strokeWidth={2} />
              <span className="font-body text-sm md:text-base">No credit card required</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={18} color="#FFFFFF" strokeWidth={2} />
              <span className="font-body text-sm md:text-base">14-day free trial</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={18} color="#FFFFFF" strokeWidth={2} />
              <span className="font-body text-sm md:text-base">Cancel anytime</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;